export default {
  'ok': '确认',
  'receive': '收取',
  'my rewards': '我的奖励',
};